import script from "./GalleryShowcaseBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryShowcaseBlock.vue?vue&type=script&setup=true&lang=js"

import "./GalleryShowcaseBlock.vue?vue&type=style&index=0&id=cfeba3de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfeba3de"]])

export default __exports__